import MainContainer from 'src/containers/MainContainer'
import { withLocalePaths, withLocaleProps } from 'src/locale/withLocale'
import Head from 'next/head'
import { textFactory } from 'src/locale/textFactory'


export default function Main() {
  const text = textFactory()

  return (
    <>
      <Head>
        <title>{ text.MainPage_title }</title>
        <meta
          name="description"
          content={ text.MainPage_description }
        />
      </Head>
      <MainContainer />
    </>
  )
}

export const getStaticProps = withLocaleProps()
export const getStaticPaths = withLocalePaths()
